import React, { useEffect, useState } from 'react';
import Image from 'next/image';
import moment from 'moment';

/**
 * @description 공지 배터 띄우기
 * @export
 * @param {Object} common - PC/MOBILE 공통 요소
 * @param {string} common.displayPeriod - 노출 기간 `fromDateTime` ~ `toDateTime`
 * @param {string} common.bannerTitle - 배너 내용
 * @param {string} common.bannerLink - 배너 클릭시 타겟 링크
 * @param {Object} deviceData - PC/MOBILE 별 노출 데이터
 * @param {string} deviceData.bannerImg - 배너 이미지
 * @param {string} deviceData.bannerBackgroundColor - 배너 이미지 배경색
 */
export default function MainBottomEventBanner ({ common, deviceData }) {
  const currentDateTime = moment().toDate();
  const fromDateTime = moment(common.displayPeriod.fromDateTime).toDate();
  const toDateTime = moment(common.displayPeriod.toDateTime).toDate();
  const timeCheck = currentDateTime >= fromDateTime && toDateTime >= currentDateTime ? 'Y' : 'N';

  const [mainBottomEventBannerYN, setMainBottomEventBannerYN] = useState(timeCheck);

  function closing () {
    setMainBottomEventBannerYN('N');
  }

  if (mainBottomEventBannerYN === 'N') {
    return null;
  } else {
    return (
      <div id='banner' className='fixed_banner_w' style={{ backgroundColor: deviceData.bannerBackgroundColor }}>
        <div className='fixed_banner_inner'>
          <div className='fixed_banner' style={{ justifyContent: 'center' }}>
            <a href={deviceData.bannerLink} target='_blank' rel='noreferrer'>
              <Image
                src={deviceData.bannerImg} alt={common.bannerTitle} className='fixed_banner_img'
                width={1024} height={82} layout='fixed' quality={75}
              />
            </a>
          </div>
          <div className='fixed_banner_btns'>
            <button type='button' className='fixed_banner_btn_closed' onClick={() => closing()}>
              <span className='fixed_banner_icon_closed'>
                <svg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 10 10'>
                  <path className='a' d='M12.17,1.271.521,1.434A.572.572,0,0,1,0,.806H0A.612.612,0,0,1,.538.163L12.188,0a.572.572,0,0,1,.521.628h0A.612.612,0,0,1,12.17,1.271Z' transform='translate(1.014 0) rotate(45)' />
                  <path className='a' d='M12.17.163.521,0A.572.572,0,0,0,0,.628H0a.612.612,0,0,0,.538.643l11.649.163a.572.572,0,0,0,.521-.628h0A.612.612,0,0,0,12.17.163Z' transform='translate(10 1.014) rotate(135)' />
                </svg>
              </span>
            </button>
          </div>
        </div>
      </div>
    );
  }
}
